import BaseStore from "./BaseStore";

class DelegateStore extends BaseStore {
  ///add delegate
  addDelegateStore(user, type, reply){
      return this.axios.post('/'+type, { [type+'_id']: user,
        reply: reply
     });
  }

  //remove delegate
  removeDelegateStore(user, type) {
    return this.axios.delete("/"+type+"/" + user[type+"_id"]);
  }

  //edit delegate
  editDelegateStore(user, type, reply) {
    // console.log(user)
    return this.axios.patch("/reviewer/"+user.reviewer_id, {
      id: user.reviewer_id,
      reply: reply
    });
  }

  //list delegates
  listUsers(type) {
    return this.axios.get("/"+type);
  }

  getUsersOnBehalf() {
    return this.axios.get("/delegate/behalf");
  }

  getUsersOnReviewerReply(doc_id) {
    return this.axios.get("/reviewer/behalf_reply",{
      params:{
        document_id: doc_id
      }
    });
  }

  getUsersOnBehalfReviewer() {
    return this.axios.get("/reviewer/behalf");
  }
}
export default new DelegateStore();



// WEBPACK FOOTER //
// ./src/stores/DelegateStore.js